module.exports = __webpack_public_path__ + "static/img/yinying1.53d6465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/yinying1.png
// module id = FKMz
// module chunks = 69